<template>
  <div class="min-h-screen px-6 md:px-10 py-10">
    <div class="mb-8">
      <h1 class="text-3xl text-gray-900">Configurações</h1>
      <p class="text-sm text-gray-500 mt-1">Ajustes gerais da plataforma.</p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 max-w-3xl">
      <div @click="irParaEtiquetas"
        class="card-access group cursor-pointer rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
        <div class="flex items-center justify-center gap-2 rounded-t-2xl bg-gray-100 px-3 py-3">
          <svg class="h-4 w-4 text-blue-600 transition-all duration-300 group-hover:scale-110 group-hover:text-blue-700"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z">
            </path>
          </svg>
          <p class="text-sm font-medium text-gray-800">Tabulações / Etiquetas</p>
        </div>

        <div class="px-3 py-3">
          <div
            class="flex items-center justify-center gap-1 text-sm font-medium text-gray-700 transition group-hover:text-blue-600">
            Acessar
            <svg class="card-access-arrow h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 17L17 7M8 7h9v9"></path>
            </svg>
          </div>
        </div>
      </div>

      <div @click="irParaMensagens"
        class="card-access group cursor-pointer rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
        <div class="flex items-center justify-center gap-2 rounded-t-2xl bg-gray-100 px-3 py-3">
          <svg class="h-4 w-4 text-blue-600 transition-all duration-300 group-hover:scale-110 group-hover:text-blue-700"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z">
            </path>
          </svg>
          <p class="text-sm font-medium text-gray-800">Mensagens Pré Definidas</p>
        </div>

        <div class="px-3 py-3">
          <div
            class="flex items-center justify-center gap-1 text-sm font-medium text-gray-700 transition group-hover:text-blue-600">
            Acessar
            <svg class="card-access-arrow h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 17L17 7M8 7h9v9"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 2xl:grid-cols-2 gap-6">
      <div class="space-y-6">
        <div v-if="!isClienteBluesend" class="bg-white border border-gray-200 rounded-2xl shadow-sm p-6">
          <div class="flex items-center justify-between mb-4">
            <div>
              <h2 class="text-base font-semibold text-gray-900">Notificações</h2>
              <p class="text-sm text-gray-500 mt-1">Email para avisos de campanhas e validações.</p>
            </div>

            <div class="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
                </path>
              </svg>
            </div>
          </div>

          <input v-model="emailNotificacao" type="email" placeholder="seuemail@empresa.com"
            class="w-full h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />
        </div>

        <div class="bg-white border border-gray-200 rounded-2xl shadow-sm p-6">
          <div class="flex items-center justify-between mb-4">
            <div>
              <h2 class="text-base font-semibold text-gray-900">Aparência</h2>
              <p class="text-sm text-gray-500 mt-1">Cor principal da plataforma.</p>
            </div>

            <div class="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01">
                </path>
              </svg>
            </div>
          </div>

          <div class="space-y-4">
            <div class="flex flex-wrap gap-3">
              <input v-model="corPrincipal" type="text" placeholder="#000000"
                class="h-11 min-w-45 flex-1 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />
              <button type="button" @click="limparCor"
                class="h-11 px-4 rounded-xl bg-white border border-gray-200 text-sm text-gray-700 hover:bg-gray-50 transition font-medium">Limpar
                cor</button>
            </div>

            <div class="rounded-2xl border-2 border-gray-200 p-6 bg-gradient-to-br from-gray-50 to-white">
              <div class="space-y-4">
                <p class="text-sm font-medium text-gray-700">Selecione uma cor:</p>
                <input v-model="corPrincipal" type="color"
                  class="w-full h-16 border border-gray-300 rounded-xl cursor-pointer" />

                <div class="pt-2 flex items-center gap-3">
                  <div class="h-12 w-12 rounded-lg border border-gray-200" :style="{ backgroundColor: corPrincipal }">
                  </div>
                  <span class="text-sm text-gray-600">Cor selecionada: <strong>{{ corPrincipal }}</strong></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white border border-gray-200 rounded-2xl shadow-sm p-6">
          <div class="flex items-center justify-between mb-4">
            <div>
              <h2 class="text-base font-semibold text-gray-900">Integração</h2>
              <p class="text-sm text-gray-500 mt-1">Dados para comunicação com sistemas externos.</p>
            </div>

            <div class="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z">
                </path>
              </svg>
            </div>
          </div>

          <div class="space-y-4">
            <button type="button" @click="alternarIntegracao"
              class="h-10 px-4 rounded-xl bg-white border border-gray-200 text-sm text-gray-700 hover:bg-gray-50 transition">
              {{ mostrarIntegracao ? "Ocultar integração" : "Ver integração" }}
            </button>

            <div v-if="mostrarIntegracao" class="space-y-4 pt-2">
              <textarea v-model="tokenIntegracao" rows="5" readonly
                :placeholder="carregandoTokenIntegracao ? 'Carregando token...' : 'Token de integração indisponível'"
                class="w-full border border-gray-200 rounded-2xl px-4 py-3 outline-none resize-none bg-gray-50 focus:ring-2 focus:ring-blue-100"></textarea>

              <input v-model="idCustom" type="text" placeholder="ID Custom"
                class="w-full h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />

              <div class="flex gap-3">
                <button type="button" @click="copiarToken" :disabled="!tokenIntegracao"
                  class="px-4 py-2 rounded-lg bg-white border border-gray-200 text-sm text-gray-700 hover:bg-gray-50 transition disabled:cursor-not-allowed disabled:opacity-50">Copiar
                  token</button>

                <button type="button"
                  class="px-4 py-2 rounded-lg bg-blue-500 text-white text-sm font-medium hover:bg-blue-600 transition">Salvar
                  integração</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="space-y-6">
        <div class="bg-white border border-gray-200 rounded-2xl shadow-sm p-6">
          <div class="flex items-center justify-between mb-4">
            <div>
              <h2 class="text-base font-semibold text-gray-900">Logo</h2>
              <p class="text-sm text-gray-500 mt-1">Envie a identidade visual da plataforma.</p>
            </div>

            <div class="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
                </path>
              </svg>
            </div>
          </div>

          <div class="space-y-3">
            <label
              class="border-2 border-dashed border-gray-200 rounded-2xl h-44 flex items-center justify-center overflow-hidden text-sm text-gray-500 cursor-pointer hover:border-blue-300 hover:bg-blue-50/40 transition">
              <input type="file" accept="image/png,image/jpeg,image/jpg,image/webp" class="hidden"
                @change="onFileChange" />
              <span class="flex h-full w-full flex-col items-center justify-center gap-3 px-4 text-center">
                <img v-if="logoPreviewUrl" :src="logoPreviewUrl" alt="Preview da logo"
                  class="max-h-24 w-full max-w-xs object-contain" />
                <span>{{ logoPreviewUrl ? "Trocar logo" : "Enviar logo" }}</span>
              </span>
            </label>
            <button type="button" @click="limparLogo"
              class="w-full h-10 rounded-xl bg-white border border-gray-200 text-sm text-gray-700 hover:bg-gray-50 transition font-medium">Limpar
              logo</button>
          </div>
        </div>

        <div class="bg-white border border-gray-200 rounded-2xl shadow-sm p-6">
          <div class="flex items-center justify-between mb-4">
            <div>
              <h2 class="text-base font-semibold text-gray-900">Automações</h2>
              <p class="text-sm text-gray-500 mt-1">Regras automáticas da conta.</p>
            </div>

            <div class="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z">
                </path>
              </svg>
            </div>
          </div>

          <div class="space-y-4">
            <label class="flex items-center gap-3 cursor-pointer">
              <input v-model="limiteMensalAtivo" type="checkbox"
                class="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
              <span class="text-sm text-gray-700">Ativar limite mensal</span>
            </label>

            <input v-if="limiteMensalAtivo" v-model="limiteMensal" type="number" placeholder="Informe o limite mensal"
              class="w-full h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />

            <div class="border-t border-gray-100 pt-4 space-y-3">
              <label class="flex items-center gap-3 cursor-pointer">
                <input v-model="mensagemAutomaticaAtiva" type="checkbox"
                  class="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                <span class="text-sm text-gray-700">Ativar resposta automática</span>
              </label>

              <div v-if="mensagemAutomaticaAtiva" class="space-y-2">
                <label for="mensagemAutomatica" class="block text-sm font-medium text-gray-700">
                  Mensagem
                </label>
                <textarea id="mensagemAutomatica" v-model="mensagemAutomatica" rows="4"
                  placeholder="Digite a mensagem enviada automaticamente"
                  class="w-full border border-gray-200 rounded-2xl px-4 py-3 outline-none resize-y focus:ring-2 focus:ring-blue-100"></textarea>
                <p class="text-xs leading-relaxed text-gray-500">
                  Enviada quando um contato responde a uma campanha LZV2. A mesma resposta não será reenviada no chat
                  durante 60 minutos.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-white border border-gray-200 rounded-2xl shadow-sm p-6">
          <div class="flex items-center justify-between mb-4">
            <div>
              <h2 class="text-base font-semibold text-gray-900">Limitação de horários</h2>
              <p class="text-sm text-gray-500 mt-1">Restrinja campanhas e novas conversas por faixa de horário.</p>
            </div>

            <div class="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
          </div>

          <div class="flex flex-col gap-4">
            <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <label class="flex items-center gap-3 cursor-pointer">
                <input v-model="limitarHorario" type="checkbox"
                  class="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                <span class="text-sm text-gray-700"> Limitar horário de envio </span>
              </label>

              <button type="button" @click="mostrarHorarioConfig = !mostrarHorarioConfig" :disabled="!limitarHorario"
                class="h-10 px-4 rounded-xl bg-white border border-gray-200 text-sm text-gray-700 hover:bg-gray-50 transition disabled:opacity-50">
                {{ mostrarHorarioConfig ? "Ocultar configuração" : "Configurar horários" }}
              </button>
            </div>

            <div v-if="limitarHorario && mostrarHorarioConfig"
              class="border-t border-gray-100 pt-4 grid grid-cols-1 xl:grid-cols-2 gap-4">
              <div class="rounded-2xl border border-gray-200 p-4">
                <h3 class="text-sm font-semibold text-gray-900 mb-3">Dias úteis</h3>

                <div class="space-y-3">
                  <div class="grid grid-cols-2 gap-3">
                    <input v-model="horarios.semana.campanhasInicio" type="time"
                      class="h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />
                    <input v-model="horarios.semana.campanhasFim" type="time"
                      class="h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />
                  </div>

                  <div class="grid grid-cols-2 gap-3">
                    <input v-model="horarios.semana.conversasInicio" type="time"
                      class="h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />
                    <input v-model="horarios.semana.conversasFim" type="time"
                      class="h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />
                  </div>
                </div>
              </div>

              <div class="rounded-2xl border border-gray-200 p-4">
                <h3 class="text-sm font-semibold text-gray-900 mb-3">Fim de semana</h3>

                <div class="space-y-3">
                  <div class="grid grid-cols-2 gap-3">
                    <input v-model="horarios.fimSemana.campanhasInicio" type="time"
                      class="h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />
                    <input v-model="horarios.fimSemana.campanhasFim" type="time"
                      class="h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />
                  </div>

                  <div class="grid grid-cols-2 gap-3">
                    <input v-model="horarios.fimSemana.conversasInicio" type="time"
                      class="h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />
                    <input v-model="horarios.fimSemana.conversasFim" type="time"
                      class="h-11 border border-gray-200 rounded-xl px-4 outline-none focus:ring-2 focus:ring-blue-100" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end mt-8 gap-3">
      <button
        class="px-5 py-3 rounded-xl bg-white border border-gray-200 text-gray-700 font-medium hover:bg-gray-50 transition">Cancelar</button>

      <button @click="salvarConfiguracao" :disabled="salvandoConfig"
        class="px-5 py-3 rounded-xl bg-blue-500 text-white font-medium hover:bg-blue-600 transition shadow-sm disabled:cursor-not-allowed disabled:opacity-60">
        {{ salvandoConfig ? "Salvando..." : "Salvar alterações" }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emailNotificacao: "",
      corPrincipal: "#000000",
      mostrarPaleta: false,
      previewLogo: null,
      selectedLogoFile: null,
      salvandoConfig: false,

      limitarHorario: false,
      mostrarHorarioConfig: false,

      limiteMensalAtivo: false,
      limiteMensal: "",
      mensagemAutomaticaAtiva: false,
      mensagemAutomatica: "",

      mostrarIntegracao: false,
      tokenIntegracao: "",
      carregandoTokenIntegracao: false,
      idCustom: "",

      horarios: {
        semana: {
          campanhasInicio: "04:00",
          campanhasFim: "17:00",
          conversasInicio: "04:00",
          conversasFim: "23:00"
        },
        fimSemana: {
          campanhasInicio: "04:00",
          campanhasFim: "16:00",
          conversasInicio: "04:00",
          conversasFim: "17:00"
        }
      }
    };
  },
  computed: {
    logoPreviewUrl() {
      return this.previewLogo || this.buildLogoUrl(this.$store.state.logo);
    },
    currentAccountId() {
      const user = this.$store.state.user || {};
      return user.usuario || user._id;
    },
    isClienteBluesend() {
      const user = this.$store.state.user || {};
      const accountId = user.operador ? user.usuario : user._id;
      return !!(user.lzv2 && user.lzv2.cliente_bluesend) || String(accountId || '') === '66eac8eef58389f70fad372d';
    }
  },
  watch: {
    limitarHorario(val) {
      if (!val) this.mostrarHorarioConfig = false;
    },
    currentAccountId(id) {
      if (id && !this.tokenIntegracao) {
        this.carregarTokenIntegracao();
      }
    }
  },
  methods: {
    normalizeColor(value) {
      const fallback = "#000000";

      if (typeof value !== "string") {
        return fallback;
      }

      const color = value.trim();
      return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(color) ? color : fallback;
    },
    limparCor() {
      this.corPrincipal = "#000000";
    },
    limparLogo() {
      if (this.previewLogo) {
        URL.revokeObjectURL(this.previewLogo);
      }
      this.previewLogo = null;
      this.selectedLogoFile = null;
      this.$store.commit("setConfig", {
        colorPrincipal: this.$store.state.colorPrincipal,
        logo: null
      });
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
    },
    irParaEtiquetas() {
      this.$router.push({ name: "Tag" });
    },
    irParaMensagens() {
      this.$router.push({ name: "PreMensagem" });
    },
    async alternarIntegracao() {
      this.mostrarIntegracao = !this.mostrarIntegracao;

      if (this.mostrarIntegracao && !this.tokenIntegracao) {
        await this.carregarTokenIntegracao();
      }
    },
    async carregarTokenIntegracao() {
      if (!this.currentAccountId || this.carregandoTokenIntegracao) return;

      try {
        this.carregandoTokenIntegracao = true;
        const response = await this.$http.get(`/v1/users/token/${this.currentAccountId}`);
        const data = response && response.data ? response.data : {};

        if (data.success === false || !data.token) {
          throw new Error(data.err || "Erro ao carregar token de integração");
        }

        this.tokenIntegracao = data.token;
      } catch (error) {
        console.error("Erro ao carregar token de integração:", error);
        this.tokenIntegracao = "";
        if (this.$vToastify) {
          this.$vToastify.error(error.message || "Erro ao carregar token de integração");
        }
      } finally {
        this.carregandoTokenIntegracao = false;
      }
    },
    onFileChange(event) {
      const file = event.target.files?.[0];
      if (!file) return;
      if (this.previewLogo) URL.revokeObjectURL(this.previewLogo);
      this.selectedLogoFile = file;
      this.previewLogo = URL.createObjectURL(file);
    },
    buildLogoUrl(logo) {
      if (!logo || !logo.filename) return null;

      const params = new URLSearchParams();
      params.set("mimetype", logo.mimetype || "image/jpeg");
      params.set("filename", logo.filename);
      params.set("folder", logo.folder || "arquivosWhats");

      return `${this.api}/upload?${params.toString()}`;
    },
    async uploadLogoSelecionada() {
      if (!this.selectedLogoFile) return this.$store.state.logo || null;

      const formData = new FormData();
      formData.append("file", this.selectedLogoFile);
      formData.append("folder", "arquivosWhats");

      const response = await this.$http.post("/upload", formData);
      const data = response && response.data ? response.data : {};

      if (data.success === false || !data.file || !data.file.filename) {
        throw new Error(data.err || "Erro ao enviar logo");
      }

      return data.file;
    },
    async copiarToken() {
      try {
        await navigator.clipboard.writeText(this.tokenIntegracao);
        console.log("Token copiado");
      } catch {
        console.log("Erro ao copiar token");
      }
    },
    async carregarConfiguracoes() {
      try {
        const response = await this.$http.post("/v1/users/meLZV2");
        let userData = response && response.data ? response.data : {};

        if (userData && (userData.success === true || userData.success === false) && userData.data) {
          userData = userData.data;
        } else if (userData && userData.data && (userData.data._id || userData.data.usuario)) {

          userData = userData.data;
        }

        if (userData && (userData._id || userData.usuario)) {
          
          const currentUser = this.$store.state.user || {};
          const mergedUser = Object.assign({}, currentUser, userData);

          this.$store.commit("login", mergedUser);
          try {
            localStorage.setItem("user", JSON.stringify(mergedUser));
          } catch (e) {
            console.warn("Erro ao salvar no localStorage:", e);
          }

          return mergedUser;
        }

        return userData;
      } catch (error) {
        console.warn("Erro ao carregar configurações do servidor:", error);
    
        return this.$store.state.user || {};
      }
    },
    preencherCamposComConfiguracao(user) {
      if (!user) return;


      this.corPrincipal = this.normalizeColor(user.colorPrincipal || this.$store.state.colorPrincipal);


      if (user.limitarHorariolzv2 !== undefined) {
        this.limitarHorario = user.limitarHorariolzv2;
      }


      if (user.horario_campanhalzv2) {
        this.horarios.semana.campanhasInicio = user.horario_campanhalzv2.semana_inicio || "04:00";
        this.horarios.semana.campanhasFim = user.horario_campanhalzv2.semana_fim || "17:00";
        this.horarios.fimSemana.campanhasInicio = user.horario_campanhalzv2.fim_semana_inicio || "04:00";
        this.horarios.fimSemana.campanhasFim = user.horario_campanhalzv2.fim_semana_fim || "16:00";
      }


      if (user.horario_chatlzv2) {
        this.horarios.semana.conversasInicio = user.horario_chatlzv2.semana_inicio || "04:00";
        this.horarios.semana.conversasFim = user.horario_chatlzv2.semana_fim || "23:00";
        this.horarios.fimSemana.conversasInicio = user.horario_chatlzv2.fim_semana_inicio || "04:00";
        this.horarios.fimSemana.conversasFim = user.horario_chatlzv2.fim_semana_fim || "17:00";
      }


      if (user.limiteMensal) {
        this.limiteMensalAtivo = user.limiteMensal.ativo || false;
        this.limiteMensal = user.limiteMensal.volume || "";
      }

      if (user.mensagemAutomatica) {
        this.mensagemAutomaticaAtiva = user.mensagemAutomatica.ativo === true;
        this.mensagemAutomatica = user.mensagemAutomatica.mensagem || "";
      } else {
        this.mensagemAutomaticaAtiva = false;
        this.mensagemAutomatica = "";
      }

      if (user.idCustom) {
        this.idCustom = user.idCustom;
      }

      if (Object.prototype.hasOwnProperty.call(user, "emailNotification")) {
        this.emailNotificacao = user.emailNotification || "";
      }
    },
    async salvarConfiguracao() {
      if (this.salvandoConfig) return;

      try {
        this.salvandoConfig = true;

        if (this.mensagemAutomaticaAtiva && !this.mensagemAutomatica.trim()) {
          throw new Error("Informe a mensagem da resposta automática");
        }

        const colorPrincipal = this.normalizeColor(this.corPrincipal);
        const logo = await this.uploadLogoSelecionada();

        const config = {
          _id: this.currentAccountId,
          colorPrincipal,
          logo,
          limitarHorariolzv2: this.limitarHorario,
          horario_campanhalzv2: {
            semana_inicio: this.horarios.semana.campanhasInicio,
            semana_fim: this.horarios.semana.campanhasFim,
            fim_semana_inicio: this.horarios.fimSemana.campanhasInicio,
            fim_semana_fim: this.horarios.fimSemana.campanhasFim,
          },
          horario_chatlzv2: {
            semana_inicio: this.horarios.semana.conversasInicio,
            semana_fim: this.horarios.semana.conversasFim,
            fim_semana_inicio: this.horarios.fimSemana.conversasInicio,
            fim_semana_fim: this.horarios.fimSemana.conversasFim,
          },
          limiteMensal: {
            ativo: this.limiteMensalAtivo,
            volume: this.limiteMensal ? parseInt(this.limiteMensal, 10) : 0,
          },
          mensagemAutomatica: {
            ativo: this.mensagemAutomaticaAtiva,
            mensagem: this.mensagemAutomatica
          },
          idCustom: this.idCustom
        };

        if (!this.isClienteBluesend) {
          config.emailNotification = this.emailNotificacao;
        }

        console.debug("salvarConfiguracao - payload:", config);
        const response = await this.$http.put("/v1/users", config);
        const responseData = response && response.data ? response.data : null;
        console.debug("salvarConfiguracao - response:", responseData);

        if (responseData && responseData.success === false) {
          throw new Error(responseData.err || "Erro ao salvar configurações");
        }

        if (responseData) {
          const savedUser = responseData.data || responseData;
          const currentUser = this.$store.state.user || {};
     
          const updatedUser = Object.assign({}, currentUser, {
            colorPrincipal,
            logo: savedUser.logo || logo,
            limitarHorariolzv2: (typeof config.limitarHorariolzv2 !== 'undefined') ? config.limitarHorariolzv2 : savedUser.limitarHorariolzv2,
            horario_campanhalzv2: config.horario_campanhalzv2 || savedUser.horario_campanhalzv2,
            horario_chatlzv2: config.horario_chatlzv2 || savedUser.horario_chatlzv2,
            limiteMensal: config.limiteMensal || savedUser.limiteMensal,
            mensagemAutomatica: config.mensagemAutomatica || savedUser.mensagemAutomatica,
            idCustom: config.idCustom || savedUser.idCustom
          });

          if (!this.isClienteBluesend) {
            updatedUser.emailNotification = config.emailNotification || savedUser.emailNotification || this.emailNotificacao;
          }

          this.$store.commit("setConfig", {
            colorPrincipal,
            logo: updatedUser.logo
          });

          this.$store.commit("login", updatedUser);

          try {
            localStorage.setItem("user", JSON.stringify(updatedUser));
          } catch (e) {
            console.warn("Erro ao salvar no localStorage:", e);
          }

          if (this.previewLogo) {
            URL.revokeObjectURL(this.previewLogo);
            this.previewLogo = null;
          }
          this.selectedLogoFile = null;

          if (this.$vToastify) {
            this.$vToastify.success("Configurações salvas com sucesso!");
          }

          this.preencherCamposComConfiguracao(updatedUser);
        } else {
          throw new Error("Resposta inválida do servidor");
        }
      } catch (error) {
        console.error("Erro ao salvar configurações:", error);
        if (this.$vToastify) {
          this.$vToastify.error(error.message || "Erro ao salvar configurações");
        }
      } finally {
        this.salvandoConfig = false;
      }
    }
  },
  beforeDestroy() {
    if (this.previewLogo) URL.revokeObjectURL(this.previewLogo);
  },
  async mounted() {
    const serverUser = await this.carregarConfiguracoes();
    this.preencherCamposComConfiguracao(serverUser);

    this.carregarTokenIntegracao();
  }
};
</script>

<style scoped>
.card-access-arrow {
  display: inline-block;
  transform-origin: center;
  transform: rotate(0deg);
  transition: transform 0.22s ease-out;
  will-change: transform;
}

.card-access:hover .card-access-arrow {
  transform: rotate(42deg);
}
</style>
